import { Component } from 'react';
import PT from 'prop-types';
import Combokeys from 'combokeys';

class KeyCapture extends Component {
  componentDidMount() {
    const { sequence, onCapture, block } = this.props;
    this.combokeys = new Combokeys(global.document.documentElement);
    this.combokeys.bind(sequence, (e) => {
      if (block) {
        e.preventDefault();
      }
      onCapture(e);
    });
  }

  componentWillUnmount() {
    this.combokeys.detach();
  }

  render() {
    return null;
  }
}

KeyCapture.propTypes = {
  sequence: PT.oneOfType([PT.string, PT.arrayOf(PT.string)]).isRequired,
  onCapture: PT.func.isRequired,
  block: PT.bool,
};

export default KeyCapture;
